import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { bindCallback, Observable } from 'rxjs';

import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ApiKlarnaService {
    constructor(private readonly http: HttpClient, private readonly requestService: HttpRequestsService) {}

    public beginSession(storeId: string, languageId: string, orderId: number, type: KlarnaType): Observable<KlarnaSession> {
        const slug = `order/store/${storeId}/order/${orderId}/klarna/session`;
        const url = this.requestService.requestUrl(slug, languageId);
        return this.http.post<KlarnaSession>(url, { type }, { withCredentials: true });
    }

    public authorizePayment(
        storeId: string,
        languageId: string,
        orderId: number,
        type: KlarnaType
    ): Observable<KlarnaAuthorizePaymentResult> {
        const slug = `order/store/${storeId}/order/${orderId}/klarna/authorisedata`;
        const url = this.requestService.requestUrl(slug, languageId);
        return this.http.post<KlarnaAuthorizePaymentResult>(url, { type }, { withCredentials: true });
    }

    public authorizeOrder(
        type: ApiKlarnaType,
        _authorizationInfo: KlarnaAuthorizeOrderConfig
    ): Observable<KlarnaAuthorizeOrderResult> {
        // El jira ECOMDUTI-15803 nos fuerza a hacer que el valor de la propiedad update se pase vacío y por eso forzamos este undefined para no esperar la solucion de back
        return bindCallback(Klarna.Payments.authorize)({ payment_method_category: type }, undefined);
    }
}
